export function ensureSetup(): {
	brand: string;
	market: { name: string };
	device: string;
	clientId: string;
	kvps: any;
	url?: string;
} {
	const existing = localStorage.getItem('setup');
	let setup;

	function extractPrefixFromUrl(url: string): string {
		try {
			const hostname = new URL(url).hostname;
			return hostname.replace('.did.b12-ssp.de', '');
		} catch {
			return 'unknown';
		}
	}

	if (existing) {
		setup = JSON.parse(existing);

		// todo if client id is empty or missing, re-set it
		if (!setup.clientId) {
			if (localStorage.getItem('kvps') && setup.device) {
				setup.clientId = `${localStorage.getItem('kvps')}_${setup.device}`;
			} else if (setup.url && setup.device) {
				const prefix = extractPrefixFromUrl(setup.url);
				setup.clientId = `${prefix}_${setup.device}`;
			} else {
				setup.clientId = 'unknown-client';
			}
			localStorage.setItem('setup', JSON.stringify(setup));
		}
	} else {
		// fallback setup
		setup = {
			brand: 'audi',
			market: { name: 'DEU' },
			device: 'UNSET_DEVICE',
			kvps: null,
			url: null,
			clientId: 'unknown-client',
		};

		if (localStorage.getItem('kvps') && setup.device !== 'UNSET_DEVICE') {
			setup.clientId = `${localStorage.getItem('kvps')}_${setup.device}`;
		} else if (setup.url && setup.device !== 'UNSET_DEVICE') {
			const prefix = extractPrefixFromUrl(setup.url);
			setup.clientId = `${prefix}_${setup.device}`;
		}

		localStorage.setItem('setup', JSON.stringify(setup));
	}

	return setup;
}
